import React from "react";
import { useDispatch } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Redirect } from "react-router";
import { LogOut } from "sweet-web/redux/app/actions";

type Props = RouteComponentProps;

const Reset: React.FC<Props> = props => {
  const dispatch = useDispatch();
  dispatch(LogOut());

  return <Redirect to="/" />;
};

export default Reset;
